import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const keywordImporterSelectors = importerSelectors(
  'keyword.importer',
);

export default keywordImporterSelectors;
